import {decodeJson} from "@2d-front-monorepo/core";
import {CreatePermitCommand} from "../types/CreatePermitCommand";

/**
 * The model-level `attachments` (ICreateComponentAttachments) is a `Record<AttachmentType, FileList>`
 * living on holder, driver, residency, permit and every vehicle. A FileList is not serializable -
 * JSON.stringify turns it into junk (`{"0":{}}`), not into `undefined` - and the files are only
 * uploaded at submit, so a draft cannot carry them. Emitting `{}` instead of dropping the key means
 * the restored command needs no fixups: the buckets Permits.newFormContext seeds are already there.
 * The wire-level `arguments.attachments` (IFormAttachments) is an ARRAY of blob ids and is kept.
 *
 * `billingData` is the one server-derived value that lands inside the command
 * (ReviewPermit.onSubmit writes it from a fresh quote, including a deferredConfirmation payment
 * token). A stored price goes stale, so it is dropped; the review step re-quotes on mount.
 */
function replacer(key: string, value: unknown): unknown {
	if (key === "billingData") {
		return undefined;
	}

	if (key === "attachments" && !Array.isArray(value) && typeof value === "object" && value !== null) {
		return {};
	}

	return value;
}

/** The draft payload for a wizard's in-progress command. Never contains files or a price quote. */
export function serializeDraft(command: CreatePermitCommand): string {
	return JSON.stringify(command, replacer);
}

/** Inverse of {@link serializeDraft}. `decodeJson` revives DateTime/DateOnly/TimeOnly/TimeSpan;
 *  a corrupt or truncated payload yields `undefined` rather than a half-built command. */
export function deserializeDraft(json: string): CreatePermitCommand | undefined {
	try {
		const command = decodeJson<CreatePermitCommand>(json);
		//a valid draft always has the sub-models newFormContext seeds
		return command != null && typeof command === "object" && command.permit != null ? command : undefined;
	} catch {
		return undefined;
	}
}
